module.exports = __webpack_public_path__ + "img/Notarztwagen.2ec531ad.svg";